import { useQuery, gql } from "@apollo/client"

const ADMINABLE_GROUP_FIELDS = `
  id
  name
  description
`

const ADMINABLE_GROUPS_QUERY = gql`
  query AdminableGroups {
    adminableGroups {
      ${ADMINABLE_GROUP_FIELDS}
    }
  }
`

const useQueryAdminableGroups = () => useQuery(ADMINABLE_GROUPS_QUERY)

export { useQueryAdminableGroups }
